"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Returns a string of random alphanumeric characters.
 */

exports.randomStr = function () {
  return Math.random().toString(36).substr(2);
};

exports.capitalize = function (word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
};